<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ format == 'upload' ? 'Technical Evaluation' : 'Tender Opening'}}</h4>
        <h5 class="text-primary">[{{ stepDetails.name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i>Save/Forward/Route Config
          </button>
        </ng-container>

       
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="card shadow-sm border-0 p-4">

    <p-accordion>
      <p-accordionTab *ngFor="let row of winners; let i = index">
         <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center" style="width: 100%">
          <div >
            <strong>{{ row.vendor.name }}  </strong>
            <span *ngIf="row.vendor_status && format == 'upload'" class="p-ml-2" [ngClass]="{
                  'text-success': row.vendor_status === 'Qualified' || row.vendor_status === 'Qualify',
    'text-danger': row.vendor_status === 'Disqualified' || row.vendor_status === 'Disqualify'
                }">
             - ({{ row.vendor_status === 'Qualify' ? 'Qualified' : 
         row.vendor_status === 'Disqualify' ? 'Disqualified' : row.vendor_status }})
            </span>
          </div>
          <div class="d-flex gap-3" *ngIf="format =='upload' ">
            <button class="p-button-success p-mr-2" (click)="setStatus(row, 'Qualify')"> Qualify </button>
            <button class="p-button-danger" (click)="setStatus(row, 'Disqualify')"> Disqualify</button>
          </div>
        </div>
      </ng-template>

        <div class="row mb-4">
          <app-vender-specfic-document [proposalStep]="stepDetails" [vendorId]="row.vendor.id"  [isEdit]="stepDetails?.can_edit && format !== 'upload'" [url]="url"></app-vender-specfic-document>
         
        </div>
        <div>
        

        </div>
      </p-accordionTab>
    </p-accordion>

  </div>

</div>

